import { decode as base64_decode, encode as base64_encode } from 'base-64';

export default {
  // 🔹 Récupère l'utilisateur depuis le localStorage
  getUser: () => {
    try {
      const encoded = localStorage.getItem('user');
      if (!encoded || encoded === 'undefined') return undefined;

      const decoded = base64_decode(encoded);
      if (!decoded) return undefined;

      return JSON.parse(decoded);
    } catch (error) {
      console.error('Erreur dans getUser:', error);
      return undefined;
    }
  },

  // 🔹 Récupère le token JWT
  getToken: () => {
    const token = localStorage.getItem('token');
    return token && token.trim().length > 0 ? token : undefined;
  },

  // 🔹 Vérifie si l'utilisateur est connecté
  isLoggedIn: () => {
    const user = localStorage.getItem('user');
    return user && user.trim().length > 0;
  },

  // 🔹 Sauvegarde le token dans le localStorage
  setToken: (token) => {
    if (token && token.trim().length > 0) {
      localStorage.setItem('token', token);
    } else {
      console.warn('Tentative de stockage d’un token vide.');
    }
  },

  // 🔹 Sauvegarde l’utilisateur encodé
  setUser: (user) => {
    if (user) {
      localStorage.setItem('user', user);
    } else {
      console.warn('Tentative de stockage d’un utilisateur vide.');
    }
  },

  // 🔹 Nettoie toute la session
  clear: () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  },

  // 🔹 Gère l’enregistrement d’un utilisateur après login
  signIn(dataUserInfos) {
    try {
      if (!dataUserInfos) throw new Error('Données utilisateur invalides.');

      const userinfos = {
        last_name: dataUserInfos.last_name || '',
        first_name: dataUserInfos.first_name || '',
        role_id: dataUserInfos.role_id || null,
        phone_number: dataUserInfos.phone_number || '',
        email: dataUserInfos.email || '',
        user_id: dataUserInfos.user_id || null,
        category_id: dataUserInfos.category_id || null,
        user_type_id: dataUserInfos.user_type_id || null,
        relic: dataUserInfos.relic || '',
      };

      // Encode et sauvegarde l'utilisateur
      const encodedUser = base64_encode(JSON.stringify(userinfos));
      this.setUser(encodedUser);

    } catch (error) {
      console.error('Erreur dans signIn:', error);
    }
  },
};
